import { useRef } from "react"

import { useIsScreenSizeSmall } from "@trueskin-web/theme"

import useScrollTo from "../../../hooks/use-scroll-to"
import SubmitButton from "../components/submit-button"

import PlanCard from "./plan-card"
import PlanDetails from "./plan-details"
import PlanHeader from "./plan-header"

const Plan = ({ plan, selectedPlanId, isSubmitting, onSelect, onSubmit }) => {
  const {
    title,
    priceTitle,
    priceWithoutDiscounts,
    image,
    description,
    details,
    isSubscription,
    isRecommended,
  } = plan

  const { scrollTo } = useScrollTo()
  const isMobile = useIsScreenSizeSmall()

  const planRef = useRef()

  const shouldSelect = selectedPlanId
    ? plan.id === selectedPlanId
    : plan.isSelected

  const handleSelect = () => {
    onSelect(plan.id)

    if (isMobile) {
      planRef.current.addEventListener("transitionend", scrollToPlan)
    }
  }

  const handleSubmit = () => {
    if (selectedPlanId !== plan.id) {
      onSelect(plan.id)
    }
    onSubmit(plan.id)
  }

  const scrollToPlan = () => {
    setTimeout(() => {
      scrollTo({
        target: planRef.current,
      })

      planRef.current.removeEventListener("transitionend", scrollToPlan)
    }, 150)
  }

  return (
    <PlanCard
      isSelected={shouldSelect}
      plan={plan}
      isRecommended={isRecommended}
      onClick={handleSelect}
      ref={planRef}
    >
      <PlanHeader
        isSelected={shouldSelect}
        title={title}
        priceTitle={priceTitle}
        priceWithoutDiscounts={priceWithoutDiscounts}
        isSubscription={isSubscription}
      />
      <PlanDetails
        isSelected={shouldSelect}
        title={title}
        image={image}
        details={details}
        description={description}
        isSubscription={isSubscription}
      />
      <SubmitButton
        data-testid="web-portal-plan-selection-desktop-btn"
        isLoading={isSubmitting && plan.id === selectedPlanId}
        onClick={handleSubmit}
        sx={{ display: ["none", "block"], mt: "auto" }}
      >
        Weiter
      </SubmitButton>
    </PlanCard>
  )
}

export default Plan
